<template>
<div class="chapter">
<div class="inner_page">
<h2>Contents</h2>
<p class="s17"><a href="#/Text/Foreword">Foreword</a> by Lisa Randall</p>
<p class="s17"><a href="#/Text/Introduction">Introduction</a></p>
<p class="s17">Chapter 1. <a href="#/Text/1">Before the Data</a></p>
<p class="s17">Chapter 2. <span href="#/Text/2" title="Link target outside of Sample">Restart</span></p>
<p class="s17">Chapter 3. <span href="#/Text/3" title="Link target outside of Sample">High Energy</span></p>
<p class="s17">Chapter 4. <span href="#/Text/4" title="Link target outside of Sample">Standard Model</span></p>
<p class="s17">Chapter 5. <span href="#/Text/5" title="Link target outside of Sample">Rumours and Limits</span></p>
<p class="s17">Chapter 6. <span href="#/Text/6" title="Link target outside of Sample">First Higgs Hints and Some Crazy Neutrinos</span></p>
<p class="s17">Chapter 7. <span href="#/Text/7" title="Link target outside of Sample">Closing In</span></p>
<p class="s17">Chapter 8. <span href="#/Text/8" title="Link target outside of Sample">Discovery</span></p>
<p class="s17">Chapter 9. <span href="#/Text/9" title="Link target outside of Sample">What Next?</span></p>
<p class="s17"><span href="#/Text/Acknowledgments" title="Link target outside of Sample">Acknowledgements</span></p>
<p class="s17"><span href="#/Text/Index" title="Link target outside of Sample">Index</span></p>
<p class="s17"><span href="#/Text/Author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?38a1e758